import styles from './fieldMaxLengths.module.css';

export const DEFAULT_TEXT_MAX_LENGTH_SHORT = 100;
export const DEFAULT_TEXT_MAX_LENGTH_MEDIUM = 150;
export const DEFAULT_TEXT_MAX_LENGTH_LONG = 200;
export const DEFAULT_TEXTAREA_MAX_LENGTH = 2000;

const COUNTER_VISIBLE_FROM = 0.8;

export const textLimitProps = (max: number) => ({
  maxLength: max,
  count: {
    max,
    show: ({ count }: { count: number }) => (count >= max * COUNTER_VISIBLE_FROM ? `${count} / ${max}` : null),
  },
  classNames: { count: styles.counter },
});
